import { createStitches } from "@stitches/react";

export const { styled, css } = createStitches({
  theme: {
    colors: {
      bg: "#ffffff",
      blue: "#3353FF",
      orange: "#F14F1D",
      beige: "#eaeae4",

      textMain: "#141414",
      text100: "#B4B4B4",
    },
    fonts: {
      main: `"Heebo", sans-serif`,
      body: `'Zen Kaku Gothic Antique', sans-serif`,
    },
    fontWeights: {
      light: "300",
      body: "400",
      main: "900",
    },
    fontSizes: {
      4: "6rem",
      3: "3rem",
      "2a": "2rem",
      2: "1.5rem",
      1: "1.2rem",
      0.5: "1rem",
    },
  },
  media: {
    mobile: "(max-width: 1100px)",
  },
});
